<script>
import Drawer from "@/components/drawer";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import MultiSelect from "vue-multiselect";
import Swal from "sweetalert2";

// Custom Components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import Middleware from "@/helpers/middlewares";

export default {
  data() {
    return {
      title: "Staff Group",
      openDrawer: false,
      staff_group: {
        name: "",
        start_datetime: moment().format("YYYY-MM-DD HH:mm"),
        expire_datetime: moment().add(24, "hour").format("YYYY-MM-DD HH:mm"),
        is_active: true,
        is_deadbolt_enable: false,
      },
      staffGroupList: [],
      selectedGroup: null,
      submitted: false,
      isBtnLoading: false,
      staffGroupId: null,
      isEdit: false,

      memberList: [],
      selectedStaff: null,
      isLoadingAddNewMemBtn: false,

      roomList: [],
      selectedRoom: null,
      isLoadingAddNewRoomBtn: false,
    };
  },
  validations: {
    staff_group: {
      name: { required },
      start_datetime: { required },
      expire_datetime: { required },
    },
  },
  computed: {
    ...authComputed,
  },
  components: {
    PageHeader,
    Drawer,
    DatePicker,
    MultiSelect,
  },
  mounted() {
    this.getStaffGroupList();
  },
  methods: {
    // Method is used to handle new staff group
    addNewStaffGroup(data) {
      if (this.openDrawer === true && data !== undefined) {
        this.isEdit = true;
        this.staffGroupId = data.id;
        this.staff_group.name = data.name;
        this.staff_group.start_datetime = moment(data.start_datetime).format(
          "YYYY-MM-DD hh:mm:ss"
        );
        this.staff_group.expire_datetime = moment(data.expire_datetime).format(
          "YYYY-MM-DD hh:mm:ss"
        );
        this.staff_group.is_active = data.is_active;
        this.staff_group.is_deadbolt_enable = data.is_deadbolt_enable;
      } else {
        this.isEdit = false;
        this.staffGroupId = null;
      }
      this.openDrawer = !this.openDrawer;
    },
    // Method is used to get staff group list
    getStaffGroupList() {
      UserService.getStaffGroupList()
        .then((response) => {
          this.staffGroupList = response;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to add and update staff group data
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {
          ...this.staff_group,
          hotel: this.hotel.id,
        };
        if (this.isEdit) {
          UserService.updateStaffGroup(this.staffGroupId, data)
            .then((response) => {
              const index = this.staffGroupList.findIndex(
                (group) => group.id == response.id
              );
              this.$set(this.staffGroupList, index, response);
              this.addNewStaffGroup();
              Middleware.notification("Group data updated !!", "success");
              this.submitted = false;
              this.isBtnLoading = false;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          UserService.createStaffGroup(data)
            .then((response) => {
              this.staffGroupList.push(response);
              Middleware.notification("New group created !!", "success");
              this.addNewStaffGroup();
              this.submitted = false;
              this.isBtnLoading = false;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },

    // STAFF RELATED METHODs

    // Method is used to get staff memeber list
    getStaffMembers(group_staff_id) {
      this.memberList = [];
      this.selectedGroup = group_staff_id;
      UserService.getStaffList()
        .then((response) => {
          response.map((item) => {
            this.memberList.push({
              id: item.id,
              name: `${item.first_name} ${item.last_name}`,
              ...item,
            });
          });
          this.selectedStaff = null;
          this.$bvModal.show("add-new-member");
        })
        .catch((error) => {
          console.log(error);
          errorHandler(error);
        });
    },
    // Method is used to add staff to staff group
    addNewMember() {
      this.isLoadingAddNewMemBtn = true;
      UserService.addAndRomoveStaff(this.selectedGroup, {
        action: "add",
        user_id: this.selectedStaff.id,
      })
        .then((response) => {
          this.staffGroupList = this.staffGroupList.map((item) => {
            if (item.id == this.selectedGroup) {
              item.key_members = response;
            }
            return item;
          });
          this.isLoadingAddNewMemBtn = false;
          this.$bvModal.hide("add-new-member");
        })
        .catch((error) => {
          this.isLoadingAddNewMemBtn = false;
          errorHandler(error);
        });
    },
    // Method is used to remove member
    removeMember(group_staff_id, member) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be remove staff from group.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.value) {
          this.selectedGroup = group_staff_id;
          UserService.addAndRomoveStaff(group_staff_id, {
            action: "remove",
            user_id: member.id,
          })
            .then((response) => {
              this.staffGroupList = this.staffGroupList.map((item) => {
                if (item.id == group_staff_id) {
                  item.key_members = response;
                }
                return item;
              });
              this.$bvModal.hide("add-new-member");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },

    // ROOM RELATED METHODs
    getRooms(group_staff_id) {
      this.roomList = [];
      this.selectedGroup = group_staff_id;
      UserService.addAndRomoveRoom(group_staff_id, { action: "available" })
        .then((response) => {
          response.map((item) => {
            if (item.lock_iot_device !== null) {
              this.roomList.push({
                id: item.id,
                name: `${item.room_number}`,
                ...item,
              });
            }
          });
          this.selectedStaff = null;
          this.$bvModal.show("add-new-room");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to add staff to staff group
    addNewRoom() {
      if (this.selectedRoom.lock_iot_device == null) {
        return Middleware.notification(
          "No IOT devices available in this room !!",
          "info"
        );
      }
      this.isLoadingAddNewRoomBtn = true;
      UserService.addAndRomoveRoom(this.selectedGroup, {
        action: "add",
        room_id: this.selectedRoom.id,
      })
        .then((response) => {
          this.staffGroupList = this.staffGroupList.map((item) => {
            if (item.id == this.selectedGroup) {
              item.group_iot_key_rooms = response;
            }
            return item;
          });
          this.isLoadingAddNewRoomBtn = false;
          this.selectedRoom = null;
          this.$bvModal.hide("add-new-room");
        })
        .catch((error) => {
          this.isLoadingAddNewRoomBtn = false;
          errorHandler(error);
        });
    },
    // Method is used to remove member
    removeRoom(group_staff_id, room) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be remove room from group.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.value) {
          this.selectedGroup = group_staff_id;
          UserService.addAndRomoveRoom(group_staff_id, {
            action: "remove",
            room_id: room.id,
          })
            .then((response) => {
              this.staffGroupList = this.staffGroupList.map((item) => {
                if (item.id == group_staff_id) {
                  item.group_iot_key_rooms = response;
                }
                return item;
              });
              this.$bvModal.hide("add-new-member");
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },

    // Method is used to cancel member add
    cancelToAddMember(is_for) {
      if (is_for == "member") {
        this.selectedStaff = null;
        this.$bvModal.hide("add-new-member");
      }
      if (is_for == "room") {
        this.selectedRoom = null;
        this.$bvModal.hide("add-new-room");
      }
    },
    // Method is used to generate avatar
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
    // Method is used to get difference between two dates
    expireIn(date2) {
      return moment().diff(date2, "days");
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      text="New Group"
      :isButton="true"
      :action="addNewStaffGroup"
    />
    <div class="card" v-for="(staff, index) in staffGroupList" :key="index">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex align-items-center flex-wrap mb-3">
              <div class="d-flex align-items-center me-5">
                <h6 class="mb-0">Satff Group Name</h6>
                <span class="mx-2">:</span>
                <p class="mb-0">{{ staff.name }}</p>
              </div>
              <div class="d-flex align-items-center me-5">
                <h6 class="mb-0">Issued Date</h6>
                <span class="mx-2">:</span>
                <p class="mb-0">
                  {{ global_format_date_and_time(staff.start_datetime) }}
                </p>
              </div>
              <div class="d-flex align-items-center me-5">
                <h6 class="mb-0">Valid Date</h6>
                <span class="mx-2">:</span>
                <p class="mb-0">
                  {{ global_format_date_and_time(staff.expire_datetime) }}
                </p>
              </div>
              <div class="me-5">
                <h6 class="mb-0">Mobile Key, RFID key</h6>
              </div>
              <div class="d-flex align-items-center">
                <h6 class="mb-0">Deadbolt Unlock</h6>
                <span class="mx-2">:</span>
                <p class="mb-0 text-capitalize">
                  {{ staff.is_deadbolt_enable }}
                </p>
              </div>
            </div>
            <div class="d-flex align-items-center flex-wrap mb-3">
              <span
                class="me-4 cursor"
                v-for="(member, mIndex) in staff.key_members"
                :key="mIndex"
                v-b-popover.hover.top="
                  `Click to remove ${member.first_name} ${member.last_name} from group.`
                "
                @click="removeMember(staff.id, member)"
              >
                <img
                  v-if="member.profile_picture"
                  :src="member.profile_picture"
                  alt=""
                  class="picture-img rounded-circle"
                />
                <span
                  v-else
                  class="d-flex align-items-center justify-content-center avatar-md-title bg-soft bg-primary text-primary rounded-circle picture-img"
                >
                  {{
                    avatarGenerator(`${member.first_name} ${member.last_name}`)
                  }}
                </span>
              </span>
              <span
                class="d-flex align-items-center justify-content-center me-4 avatar-md-title bg-white border-primary border text-primary rounded-circle picture-img cursor"
                @click="getStaffMembers(staff.id)"
              >
                <i class="fas fa-plus"></i>
              </span>
            </div>
          </div>
          <div class="col-xl-5 col-lg-8">
            <div class="d-flex flex-wrap">
              <div
                class="staff-group-table"
                v-for="(room, rIndex) in staff.group_iot_key_rooms"
                :key="rIndex"
                v-b-popover.hover.right="'Click to remove'"
                @click="removeRoom(staff.id, room)"
              >
                {{ room.room_number }}
              </div>
              <div
                class="staff-group-table"
                v-b-popover.hover="'Add new room'"
                @click="getRooms(staff.id)"
              >
                <i class="fas fa-plus px-2 text-primary cursor"></i>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-md-6">
            <div class="table-responsive">
              <table class="table staff-table-border-color mb-0">
                <tbody>
                  <tr class="bg-success bg-soft text-success">
                    <td>Main Door</td>
                    <td>Gym</td>
                  </tr>
                  <tr class="bg-success bg-soft text-success">
                    <td>Pool</td>
                    <td>Business</td>
                  </tr>
                  <tr>
                    <td class="bg-success bg-soft text-success">Laundry</td>
                    <td>Locker</td>
                  </tr>
                  <tr>
                    <td>Office</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-xl-5 col-lg-6 d-flex justify-content-end">
            <div class="d-flex align-items-end">
              <p class="mb-2 me-3">
                Expiring
                {{ Math.abs(expireIn(staff.expire_datetime)) }}
                Days
              </p>
              <i class="fas fa-wifi fs-3 mb-2 me-3"></i>
              <i class="fas fa-mobile-alt fs-2 mb-2 me-3"></i>
              <b-dropdown
                class="float-end"
                toggle-class="text-muted p-0"
                menu-class="dropdown-menu-end"
                right
                variant="white"
              >
                <template v-slot:button-content>
                  <i class="mdi mdi-dots-vertical fs-2"></i>
                </template>
                <b-dropdown-item>Open Key Log</b-dropdown-item>
                <b-dropdown-item @click="addNewStaffGroup(staff, true)"
                  >Extend Key</b-dropdown-item
                >
                <b-dropdown-item>Delete Key</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add new group -->
    <Drawer
      @close="addNewStaffGroup"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openDrawer">
        <div class="container-fluid">
          <h4>Add new group</h4>
          <hr />
          <b-form @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="group_name"
                    >Group Name <span class="text-danger">*</span>
                  </label>
                  <b-form-input
                    id="group_name"
                    type="text"
                    placeholder="enter your staff group name"
                    v-model="staff_group.name"
                    autocomplete="off"
                    :class="{
                      'is-invalid': submitted && $v.staff_group.name.$error,
                    }"
                  ></b-form-input>
                  <div v-if="submitted" class="invalid-feedback">
                    <span v-if="!$v.staff_group.name.required"
                      >Name is required.</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">
                  <label for="is_active">Active</label>
                  <div class="form-check form-switch my-1" slot="is_active">
                    <input
                      class="form-check-input"
                      id="is_active"
                      type="checkbox"
                      v-model="staff_group.is_active"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3">
                  <label for="is_deadbolt_enable">Deadbolt</label>
                  <div
                    class="form-check form-switch my-1"
                    slot="is_deadbolt_enable"
                  >
                    <input
                      class="form-check-input"
                      id="is_deadbolt_enable"
                      type="checkbox"
                      v-model="staff_group.is_deadbolt_enable"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="start_datetime"
                    >Start Time <span class="text-danger">*</span>
                  </label>
                  <date-picker
                    v-model="staff_group.start_datetime"
                    id="start-date"
                    format="YYYY-MM-DD hh:mm:ss"
                    value-type="format"
                    type="datetime"
                    placeholder="YYYY-MM-DD hh:mm:ss"
                    :clearable="false"
                    :class="{
                      'is-invalid':
                        submitted && $v.staff_group.start_datetime.$error,
                    }"
                  ></date-picker>
                  <div v-if="submitted" class="invalid-feedback">
                    <span v-if="!$v.staff_group.start_datetime.required"
                      >Start time is required.</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="expire_datetime"
                    >Expire Time <span class="text-danger">*</span></label
                  >
                  <date-picker
                    v-model="staff_group.expire_datetime"
                    id="expire-date"
                    format="YYYY-MM-DD hh:mm:ss"
                    value-type="format"
                    type="datetime"
                    placeholder="YYYY-MM-DD hh:mm:ss"
                    :clearable="false"
                    :class="{
                      'is-invalid':
                        submitted && $v.staff_group.expire_datetime.$error,
                    }"
                  ></date-picker>
                  <div v-if="submitted" class="invalid-feedback">
                    <span v-if="!$v.staff_group.expire_datetime.required"
                      >Expire time is required.</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <hr />
                <b-button
                  class="float-end ms-2"
                  variant="outline-primary"
                  type="reset"
                  @click="addNewStaffGroup"
                  >Cancel</b-button
                >
                <b-button
                  class="float-end"
                  variant="outline-primary"
                  type="button"
                  @click="onSubmit"
                >
                  <i
                    v-if="isBtnLoading"
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  ></i>
                  {{ isEdit ? "Update" : "Save" }}
                </b-button>
              </div>
            </div>
          </b-form>
        </div>
      </div>
    </Drawer>
    <!-- Modal is used to add new member  -->
    <b-modal
      id="add-new-member"
      centered
      title="Add New Memeber"
      hide-footer
      title-class="font-18"
    >
      <MultiSelect
        :options="memberList"
        v-model="selectedStaff"
        :show-labels="false"
        placeholder="Select Staff"
        track-by="id"
        label="name"
        name="staff-add"
      />
      <div class="col-md-12 mt-2">
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelToAddMember('member')"
          >Cancel
        </b-button>
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          @click="addNewMember"
          :class="{ disabled: isLoadingAddNewMemBtn }"
        >
          <i
            v-if="isLoadingAddNewMemBtn"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Add
        </b-button>
      </div>
    </b-modal>
    <!-- Modal is used to add new room  -->
    <b-modal
      id="add-new-room"
      centered
      title="Add New Room"
      hide-footer
      title-class="font-18"
    >
      <MultiSelect
        :options="roomList"
        v-model="selectedRoom"
        :show-labels="false"
        placeholder="Select room"
        track-by="id"
        label="name"
        name="room-add"
      />
      <div class="col-md-12 mt-2">
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          type="reset"
          @click="cancelToAddMember('room')"
          >Cancel
        </b-button>
        <b-button
          class="float-end ms-2"
          variant="outline-primary"
          @click="addNewRoom"
          :class="{ disabled: isLoadingAddNewRoomBtn }"
        >
          <i
            v-if="isLoadingAddNewRoomBtn"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Add
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.staff-table-border-color tr td {
  text-align: center;
  border: 1px solid #80808078;
}
.staff-group-table {
  border: 1px solid #80808078;
  padding: 12px;
  min-width: 73px;
  text-align: center;
  border-collapse: collapse;
}
</style>
